'use client';
import React from 'react';
import { PostNode } from '@/types/global';
import PostRelated from '@/components/(blog)/post/PostRelatedPosts';
import { LayoutProps } from '@/types/generalSettings';
import BannerSidebar from '@/components/(features)/bannerSidebar';

interface PostAsideProps {
    post: PostNode;
    pageType?: string;
    banners?: LayoutProps.Banners | undefined;
    postRelated?: {
        data: PostNode[];
        endCursor: string | null;
        totalPosts: number;
    };
}

const PostAside: React.FC<PostAsideProps> = ({ post, banners, postRelated, pageType }) => {
    return (
        <aside className={'col-span-4 py-4'}>
            <div className='sticky top-28 space-y-5'>
                {(postRelated?.data?.length ?? 0) > 0 && (
                    <PostRelated
                        pageType={pageType}
                        slug={post?.slug || ''}
                        category={post?.categories?.nodes || []}
                        postRelatedPosts={postRelated}
                    />
                )}
                <BannerSidebar banners={banners} />
            </div>
        </aside>
    );
};

export default PostAside;
